import { render, staticRenderFns } from "./TechniciansConfig.vue?vue&type=template&id=3c9a2959"
import script from "./TechniciansConfig.vue?vue&type=script&lang=js"
export * from "./TechniciansConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports